import { render, staticRenderFns } from "./folder_actions_dropdown.vue?vue&type=template&id=6a22e266&"
import script from "./folder_actions_dropdown.vue?vue&type=script&lang=js&"
export * from "./folder_actions_dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports